<!--
 * @Author       : Lobin
 * @Date         : 2022-06-22 21:48:43
 * @LastEditors  : Lobin
 * @Description  : 
 * @LastEditTime : 2022-06-24 16:32:52
-->
<template>
  <div class="search-list">
    <div class="btns">
         <el-button type="primary" @click="addRole">添加角色</el-button>
    </div>
    <div class="search-list-data" v-loading="loading">
        <el-table :data="tableData" stripe style="width: 100%" size="medium" border height="500">
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="grant-list">
              <el-tag v-for="grant in props.row.grants" :key="grant._id">{{ grant.name }}</el-tag>
              </div>
            </template>
          </el-table-column>
            <el-table-column type="index" label="#" width="50">
            </el-table-column>
            <el-table-column prop="name" label="名称" width="180">
            </el-table-column>
            <el-table-column prop="alias" label="别称"> </el-table-column>
            <el-table-column prop="ctime" label="创建时间"> </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            width="130">
            <template slot-scope="scope">
                <el-button type="text" size="small" @click="editHandler(scope.row)">编辑</el-button>
                <el-button @click="deleteHandler(scope.row._id)" type="text" size="small">删除</el-button>
                <el-button @click="setPermission(scope.row)" type="text" size="small">授权</el-button>
            </template>
            </el-table-column>
        </el-table>
    </div>
    <el-dialog
        :title="dialogType === 'add' ? '添加角色' : '编辑角色'"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="60px" class="demo-ruleForm">
            <el-form-item label="名称" prop="name">
                <el-input v-model="ruleForm.name" placeholder="输入名称"></el-input>
            </el-form-item>
            <el-form-item label="别称" prop="alias">
                <el-input v-model="ruleForm.alias" placeholder="输入别称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')" :loading="submitting">提交</el-button>
                <el-button @click="cancelHandler">取消</el-button>
            </el-form-item>
            </el-form>
    </el-dialog>
     <el-dialog
        title="角色授权"
        :visible.sync="pdialogVisible"
        class="menu-dialog"
        width="30%"
        :before-close="handlePdialogClose">
        <el-checkbox-group v-model="checkedMenu" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="menu in menuList" :label="menu._id" :key="menu._id">{{ menu.name }}</el-checkbox>
        </el-checkbox-group>
        <span slot="footer" class="dialog-footer">
        <el-button @click="pdialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setPermissions">确 定</el-button>
      </span>
     </el-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      dialogVisible: false,
      pdialogVisible: false,
      tableData: [],
      dialogType: 'add',
      ruleForm: {
        name: '',
        alias: '',
        routerPath: '',
      },
      rules: {
        
      },
      currentId: '',
      menuList: [],
      checkedMenu: [],
      loading: false,
      submitting: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    ...mapActions({
      getRoleList: 'getRoleList',
      createRole: 'createRole',
      modifyRole: 'modifyRole',
      deleteRole: 'deleteRole',
      getMenuList: 'getMenuList',
    }),
    async getList() {
      this.loading = true;
      const data = await this.getRoleList(this.formInline);
      this.tableData = data;
      this.loading = false;
    },
    onSubmit() {
      this.getList();
    },
    addRole() {
      this.dialogVisible = true;
    },
    editHandler(data) {
      this.dialogType = 'modify';
      this.ruleForm = data;
      // eslint-disable-next-line no-underscore-dangle
      this.ruleForm.grants = data.grants.map(item => item._id);
      this.dialogVisible = true;
    },
    async deleteHandler(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await this.deleteRole(id);
        this.$message({
          type: 'success',
          message: '删除成功!',
        });
        this.getList();
      });
    },
    async submitForm() {
      this.submitting = true;
      if (this.dialogType === 'add') {
        await this.createRole(this.ruleForm);
      } else {
        await this.modifyRole(this.ruleForm);
      }
      this.$message.success('提交成功');
      this.submitting = false;
      this.dialogVisible = false;
      this.getList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    cancelHandler() {
      this.handleClose();
    },
    handlePdialogClose() {
      this.pdialogVisible = false;
    },
    async setPermission(data) {
      const menuList = await this.getMenuList();
      // eslint-disable-next-line no-underscore-dangle
      this.checkedMenu = data.grants.map(grant => grant._id);
      this.menuList = menuList;
      this.pdialogVisible = true;
      // eslint-disable-next-line no-underscore-dangle
      this.currentId = data._id;
    },
    async setPermissions() {
      await this.modifyRole({
        _id: this.currentId,
        grants: this.checkedMenu,
      });
      this.handlePdialogClose();
      this.getList();
      this.$message.success('授权成功');
    },
    handleCheckedCitiesChange() {

    },
  },
};
</script>
<style lang="less">
.menu-dialog {
  .el-checkbox {
    width: 1/3 * 100%;
    margin-right: 0;
    margin-bottom:10px;
  }
  .el-dialog__footer {
    text-align: center;
  }
}
.btns {
    margin-bottom: 10px;
}
.grant-list {
  .el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
</style>
